import createFormValueSelector from './createFormValueSelector';
import plain from './structure/plain';

export default createFormValueSelector(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/formValueSelector.js
// module id = 2045
// module chunks = 0